const utf8Decoder = new TextDecoder('utf-8', { fatal: true });
const legacyDecoder = new TextDecoder('windows-1252');

// Preserva pares substitutos: encodar caractere a caractere quebraria um emoji não-escapado.
const percentDecode = (value: string): Uint8Array => {
  const encoder = new TextEncoder();
  const bytes: number[] = [];

  for (const part of value.replace(/\+/g, ' ').split(/(%[0-9a-fA-F]{2})/)) {
    if (!part) {
      continue;
    }

    if (/^%[0-9a-fA-F]{2}$/.test(part)) {
      bytes.push(parseInt(part.slice(1), 16));
      continue;
    }

    encoder.encode(part).forEach((byte) => bytes.push(byte));
  }

  return Uint8Array.from(bytes);
};

const decodeComponent = (value: string): string => {
  const bytes = percentDecode(value);

  try {
    return utf8Decoder.decode(bytes);
  } catch {
    return legacyDecoder.decode(bytes);
  }
};

/**
 * Lê a query string preservando acentos de links gerados em latin1.
 *
 * Links de checkout pré-preenchidos (`?nome=`, `?email=`...) são montados pelos sistemas dos
 * clientes, e os legados fazem urlencode em latin1: `F%E1tima`. `URLSearchParams` decodifica
 * assumindo UTF-8 e, por exigência da spec, troca o byte inválido pelo caractere de substituição
 * (U+FFFD) em silêncio — sem lançar, ao contrário de `decodeURIComponent`. O nome corrompido segue
 * para a transação e o cadastro do cliente, e lá não há volta: o byte original só existe aqui.
 */
export const decodeSearchParams = (search: string): URLSearchParams => {
  const params = new URLSearchParams();
  const query = search.startsWith('?') ? search.slice(1) : search;

  if (!query) {
    return params;
  }

  for (const pair of query.split('&')) {
    if (!pair) {
      continue;
    }

    const separator = pair.indexOf('=');

    if (separator === -1) {
      params.append(decodeComponent(pair), '');
      continue;
    }

    params.append(decodeComponent(pair.slice(0, separator)), decodeComponent(pair.slice(separator + 1)));
  }

  return params;
};
